var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Клики"}},[_c('div',{staticClass:"mb-6"},[_c('IconWithStatistics',{attrs:{"customIcon":require('../../../assets/images/whatsapp-icon.svg'),"title":"Переходы в WhatsApp","count":_vm.total,"color":"#29c76f"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }